import React from "react";
import ItemConsumptionList from "../items/item-consumption-list";
import { fetchWorkOrderItems, updateWorkOrderItem, addWorkOrderItems, deleteWorkOrderItem } from "../../../api/work-order";
// Stable callbacks prevent parent item updates from re-triggering the fetch effect.
const updateModule = (data) => addWorkOrderItems(data.id, data.items || []);
/**
 * Work Order-specific wrapper for ItemConsumptionList
 * This component uses the generic ItemConsumptionList component
 */
const WorkOrderItemConsumptionList = ({
  items: initialItems = [],
  onItemsChange,
  disabled = false,
  workOrder,
  onWorkOrderUpdate,
  onItemsUpdate,
  onSubDialogStateChange,
}) => {
  return (
    <ItemConsumptionList
      items={initialItems}
      onItemsChange={onItemsChange}
      disabled={disabled}
      module={workOrder}
      moduleType="work_order"
      fetchItems={fetchWorkOrderItems}
      updateItem={updateWorkOrderItem}
      addItems={addWorkOrderItems}
      deleteItem={deleteWorkOrderItem}
      updateModule={updateModule}
      onModuleUpdate={onWorkOrderUpdate}
      onItemsUpdate={onItemsUpdate}
      onSubDialogStateChange={onSubDialogStateChange}
    />
  );
};

export default WorkOrderItemConsumptionList;
